/**
 * Created by yihong on 1/24/18.
 */


export default{
  wechat: {
    js: "D66ADE70755B",
    app: "1DF81F20CD7M",
    renew:'2BU45R97JD7A'
  },
  alipay: {
    js: "CD3402D6DA9F",
    app: "ZFB34XYB49X6",
    renew:'QA3R2TD56U12'
  },
  ios: '1F3X7JPT014M'
};




// WEBPACK FOOTER //
// ./src/constant/channels.js